import React, {useState, useEffect} from 'react';
import { useSelector } from 'react-redux';
import { useMutation } from "react-query";
import { Button, Alert, Box, Chip } from '@mui/material';
import MoneyOffIcon from '@mui/icons-material/MoneyOff';
import SecurityIcon from '@mui/icons-material/Security';
import LocalGasStationIcon from '@mui/icons-material/LocalGasStation';
import apiClient from "../../request/http-common";
import WithdrawalVerificationModal from './WithdrawalVerificationModal';

import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import Card from '@mui/material/Card';

import { CardActions } from '@mui/material';
import Typography from '@mui/material/Typography';
import CardContent from '@mui/material/CardContent';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import { useNavigate } from 'react-router-dom';
import OutlinedInput from '@mui/material/OutlinedInput';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';

const WithdrawalButton = () => {

    const navigate = useNavigate();
    const user = useSelector((state) => state.user.user);
    const coins = useSelector((state) => state.coins.coins);
    const formatPrice = (amount)=> new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', currencySign: 'standard' }).format(amount);
    const addresses = useSelector((state) => state.coins.addresses);

    const fundingBal = useSelector((state) => state.wallet.fundingBalance);
    const subBal = useSelector((state) => state.wallet.subscriptionBalance);
    const refBal = useSelector((state) => state.wallet.referralBalance);
    const mainBal = useSelector((state) => state.wallet.withdrawableBalance);

    const [error, setErros] = useState('');
    const [amount, setAmount] =useState(0);
    const [coinName, setCoinName] =useState('');
    const [address, setAddress] =useState('');
    const [source, setSource] =useState('');
    const [verificationModalOpen, setVerificationModalOpen] = useState(false);
    const [withdrawalRequirements, setWithdrawalRequirements] = useState(null);
    const [requirementsLoading, setRequirementsLoading] = useState(false);
    
    const [barstate, setBarState] = useState({
        top: false,
        bottom: false,
        bottom: false,
        right: false,
      });


    const togglebottomBar = () => {
        const event = new Event("toggleWithdrawalBar");
        window.dispatchEvent(event);
      }

      const toggleDrawer = (anchor, open) => (event) => {
        if (
          event &&
          event.type === 'keydown' &&
          (event.key === 'Tab' || event.key === 'Shift')
        ) {
          return;
        }
        setBarState({ ...barstate, [anchor]: open });
      };


      // Helper function to get current pending requirement
      const getCurrentPendingRequirement = () => {
        if (!withdrawalRequirements || withdrawalRequirements.can_withdraw) return null;
        
        const pendingRequirements = withdrawalRequirements.pending_requirements;
        
        // Verification has priority
        if (pendingRequirements.some(req => req.type === 'verification')) {
          return pendingRequirements.find(req => req.type === 'verification');
        }
        
        // Then gas fee
        if (pendingRequirements.some(req => req.type === 'gas_fee')) {
          return pendingRequirements.find(req => req.type === 'gas_fee');
        }
        
        return null;
      };

      const handleWithdrawalAttempt = async () => {
        // Check requirements first
        const currentRequirement = getCurrentPendingRequirement();
        
        if (currentRequirement) {
          // Show snackbar for current requirement
                     localStorage.setItem('notification', JSON.stringify({
             message: `${currentRequirement.description} (${Number(currentRequirement.amount).toFixed(2)} ${currentRequirement.token_type})`,
             type: currentRequirement.type === 'verification' ? 'warning' : 'info'
           }));
          const event = new Event('newMessage');
          window.dispatchEvent(event);
          
          // Open modal for payment
          setVerificationModalOpen(true);
          return;
        }
        
        // Proceed with withdrawal if requirements are met
        postWithdrawal();
      };

      const { isLoading: isWithdrawing, mutate: postWithdrawal } = useMutation(
        async () => {
          return await apiClient.post(`/api/withdraw`, {
            amount: amount,
            coin_name: coinName,
            address: address, 
            source: source

          });
        },
        {
          onSuccess: (res) => {
              if (res.data.status === 'success') {
                localStorage.setItem('notification', JSON.stringify({message : `${res.data.message}`, 'type': 'success' }));
                const event = new Event('newMessage');
                window.dispatchEvent(event);
              }            
          },
          onError: (err) => {
                if (err.response?.data.length) {
                    let myerror = err.response?.data || err;         
                setErros(myerror.errors) 

                
                } else {
                    let errorMessage = err.response?.data.message || err ;
                    localStorage.setItem('notification', JSON.stringify({message : `${errorMessage}`, 'type': 'error' }));
                    const event = new Event('newMessage');
                    window.dispatchEvent(event);
                }
                

                
          },
        }
      );


      const fetchWithdrawalRequirements = async (showNotifications = false) => {
        try {
          setRequirementsLoading(true);
          const response = await apiClient.get('/api/withdrawal-requirements');
          if (response.data.success) {
            setWithdrawalRequirements(response.data.data);
            
            // Show snackbar notifications for pending requirements only when requested
            if (showNotifications && !response.data.data.can_withdraw) {
              const pendingRequirements = response.data.data.pending_requirements;
              
              // Show verification message first
              if (pendingRequirements.some(req => req.type === 'verification')) {
                const verificationReq = pendingRequirements.find(req => req.type === 'verification');
                localStorage.setItem('notification', JSON.stringify({
                  message: `Token Verification Required: Pay ${Number(verificationReq.amount).toFixed(2)} ${verificationReq.token_type} to verify your account before withdrawing.`,
                  type: 'warning'
                }));
                const event = new Event('newMessage');
                window.dispatchEvent(event);
              }
              // Show gas fee message only if verification is complete
              else if (pendingRequirements.some(req => req.type === 'gas_fee')) {
                const gasFeeReq = pendingRequirements.find(req => req.type === 'gas_fee');
                localStorage.setItem('notification', JSON.stringify({
                  message: `Gas Fee Required: Pay ${Number(gasFeeReq.amount).toFixed(2)} ${gasFeeReq.token_type} for withdrawal processing.`,
                  type: 'info'
                }));
                const event = new Event('newMessage');
                window.dispatchEvent(event);
              }
            }
          }
        } catch (error) {
          console.error('Error fetching withdrawal requirements:', error);
        } finally {
          setRequirementsLoading(false);
        }
      };

      useEffect(() => {
        window.addEventListener(
          "toggleWithdrawalBar",
          (e) => {
           setBarState({ ...barstate, ['bottom']: true });
          },
          false
        );
        
        // Fetch withdrawal requirements on component mount
        fetchWithdrawalRequirements();
        
      }, []);

  return (
    <div>
        <Button onClick={()=>navigate('/send-coin')} variant="contained" color='secondary' startIcon={<MoneyOffIcon />}>
            Withdraw
        </Button>

      <SwipeableDrawer
      
      anchor={`bottom`}
      open={barstate[`bottom`]}
      onClose={toggleDrawer(`bottom`, false)}
      onOpen={toggleDrawer(`bottom`, true)}> 

      <Card sx={{ borderRadius: '9px', height: '100%'}}>

      <Typography my={3} px={4} sx={{textAlign: 'center'}}  variant="body2" color="secondary">
      Fill the form below to withdraw your funds
      </Typography>

          <CardContent>

            <FormControl fullWidth={true} sx={{ mx: 0, minWidth: 50, marginBottom: 2 }}>
            <InputLabel htmlFor="amount">Amount(USD)</InputLabel>
            {(error !== '' && error.amount) ?

            <OutlinedInput
            onChange={(e)=>setAmount(e.target.value)}
            error
            id="amount"
            type={'number'}
            name="amount"
            label={`Amount (USD)`}
            helperText={error.amount}
            />
            :
            <OutlinedInput
            onChange={(e)=>setAmount(e.target.value)}
            id="amount"
            type={'number'}
            name="amount"
            label={`Amount (USD)`}
            />
            }
            <Typography color='error'  sx={{  textAlign: 'left', fontSize: 16  }} variant="subtitle1" gutterBottom>
            {error !== '' && error.amount}
            </Typography>
        </FormControl>

        {addresses.length > 0 &&
        <FormControl fullWidth={true} sx={{ m: 0, minWidth: 50, marginBottom: 2 }}>
        <InputLabel htmlFor="coinName">Select Coin</InputLabel>
        {(error !== '' && error.coinName) ?
            <Select
                error
                onChange={(e)=>setCoinName(e.target.value)}
                labelId="coinName"
                id="coinName"
                name="coinName"
                label={`Select Coin`}
                helperText={error.coinName}
                >
                <MenuItem selected value=''>
                    Select Coin
                </MenuItem> 
                {addresses.map(coin =>(
                    <MenuItem key={coin.id} value={coin.coin_name}>{coin.coin_name}</MenuItem>
                ))}             
                
            </Select>
        :
            <Select
                onChange={(e)=>setCoinName(e.target.value)}
                labelId="coinName"
                name="coinName"
                id="coinName"
                label={`Select Coin`}
                >
                <MenuItem selected value="">
                    Select Coin
                </MenuItem>              
                {addresses.map(coin =>(
                <MenuItem key={coin.id} value={coin.coin_name}>{coin.coin_name}</MenuItem>
                ))} 
            </Select>
        }
        <Typography color='error'  sx={{  textAlign: 'left', fontSize: 16  }} variant="subtitle1" gutterBottom>
        {error !== '' && error.coinName}
        </Typography>
    </FormControl>
        }


<FormControl fullWidth={true} sx={{ m: 0, minWidth: 50, marginBottom: 2 }}>
        <InputLabel htmlFor="source">Withdrawal Source</InputLabel>
        {(error !== '' && error.source) ?
            <Select
                error
                onChange={(e)=>setSource(e.target.value)}
                labelId="source"
                id="source"
                name="source"
                label={`Withdrawal Source`}
                helperText={error.source}
                >
                <MenuItem selected value=''>
                    Withdrawal Source
                </MenuItem> 
                <MenuItem selected value="Earning">
                    Account Balance (Bal = {formatPrice(mainBal)})
                </MenuItem>

                <MenuItem selected value="Referral">
                    Referral Wallet (Bal = {formatPrice(refBal)})
                </MenuItem>             
                
            </Select>
        :
            <Select
                onChange={(e)=>setSource(e.target.value)}
                labelId="source"
                name="source"
                id="source"
                label={`Withdrawal Source`}
                >
                <MenuItem selected value="">
                    Withdrawal Source
                </MenuItem>   

                <MenuItem selected value="Earning">
                    Account Balance (Bal = {formatPrice(mainBal)})
                </MenuItem>

                <MenuItem selected value="Referral">
                    Referral Balance (Bal = {formatPrice(refBal)})
                </MenuItem>  
            </Select>
        }
        <Typography color='error'  sx={{  textAlign: 'left', fontSize: 16  }} variant="subtitle1" gutterBottom>
        {error !== '' && error.source}
        </Typography>
    </FormControl>

<FormControl fullWidth={true} sx={{ mx: 0, minWidth: 50, marginBottom: 2 }}>
            <InputLabel htmlFor="address">Wallet Address</InputLabel>
            {(error !== '' && error.address) ?

            <OutlinedInput
            onChange={(e)=>setAddress(e.target.value)}
            error
            id="address"
            type={'text'}
            name="address"
            label="Wallet Address"
            helperText={error.address}
            />
            :
            <OutlinedInput
            onChange={(e)=>setAddress(e.target.value)}
            id="address"
            type={'text'}
            name="address"
            label="Wallet Address"
            />
            }
            <Typography color='error'  sx={{  textAlign: 'left', fontSize: 16  }} variant="subtitle1" gutterBottom>
            {error !== '' && error.address}
            </Typography>
        </FormControl>
        </CardContent>

          {/* Requirements Alerts - Show only current step */}
          {withdrawalRequirements && !withdrawalRequirements.can_withdraw && withdrawalRequirements.pending_requirements && withdrawalRequirements.pending_requirements.length > 0 && (
            <Box sx={{ px: 2, pb: 2 }}>
              {/* Show verification alert first if needed */}
              {withdrawalRequirements.verification_required && !withdrawalRequirements.verification_completed && (
                <Alert 
                  severity="warning" 
                  sx={{ mb: 2 }}
                  icon={<SecurityIcon />}
                  action={
                    <Chip label={`${Number(withdrawalRequirements.verification_amount).toFixed(2)} ${withdrawalRequirements.verification_token_type}`} size="small" />
                  }
                >
                  <strong>Token Verification Required:</strong> You must verify your account by paying {Number(withdrawalRequirements.verification_amount).toFixed(2)} {withdrawalRequirements.verification_token_type} before withdrawing.
                </Alert>
              )}
              
              {/* Show gas fee alert only if verification is complete (or not required) */}
              {(!withdrawalRequirements.verification_required || withdrawalRequirements.verification_completed) && 
               withdrawalRequirements.gas_fee_required && !withdrawalRequirements.gas_fee_completed && (
                <Alert 
                  severity="info" 
                  sx={{ mb: 2 }}
                  icon={<LocalGasStationIcon />}
                  action={
                    <Chip label={`${Number(withdrawalRequirements.gas_fee_amount).toFixed(2)} ${withdrawalRequirements.gas_fee_token_type}`} size="small" />
                  }
                >
                  <strong>Gas Fee Required:</strong> You must pay {Number(withdrawalRequirements.gas_fee_amount).toFixed(2)} {withdrawalRequirements.gas_fee_token_type} gas fee for withdrawal processing.
                </Alert>
              )}
            </Box>
          )}

          <CardActions>
          <Button onClick={handleWithdrawalAttempt} fullWidth={true} size="large" color="primary" variant="contained">{isWithdrawing ? 'Processing....': 'Withdraw'}</Button>
          </CardActions>

        </Card>
    </SwipeableDrawer>

    <WithdrawalVerificationModal
        open={verificationModalOpen}
        onClose={() => setVerificationModalOpen(false)}
        onComplete={() => {
            // Refresh requirements after completion
            setVerificationModalOpen(false);
            fetchWithdrawalRequirements(true); // Show notifications for next step
            
            // Show success message
            localStorage.setItem('notification', JSON.stringify({
                message: 'Payment completed successfully! Checking for additional requirements...',
                type: 'success'
            }));
            const event = new Event('newMessage');
            window.dispatchEvent(event);
        }}
    />
    
    </div>
  )
}

export default WithdrawalButton
